/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChartDataDto } from '../models/ChartDataDto';
import type { Transaction } from '../models/Transaction';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TransactionsService {
    /**
     * Get transactions
     * @param type
     * @param limit
     * @param page
     * @returns any List of transactions
     * @throws ApiError
     */
    public static getTransactions(
        type?: string,
        limit?: number,
        page?: number,
    ): CancelablePromise<{
        txs?: Array<Transaction>;
        total?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tx',
            query: {
                'type': type,
                'limit': limit,
                'page': page,
            },
        });
    }
    /**
     * Get transactions by account id
     * @param accountId Account ID
     * @param lastBlock
     * @param token
     * @param txType
     * @param limit
     * @param page
     * @param order
     * @param sort
     * @returns any List of transactions
     * @throws ApiError
     */
    public static getTransactionsByAccount(
        accountId: string,
        lastBlock: number,
        token?: string,
        txType?: string,
        limit?: number,
        page?: number,
        order?: string,
        sort?: string,
    ): CancelablePromise<{
        txs?: Array<Transaction>;
        total?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tx/history/{accountId}',
            path: {
                'accountId': accountId,
            },
            query: {
                'lastBlock': lastBlock,
                'token': token,
                'txType': txType,
                'limit': limit,
                'page': page,
                'order': order,
                'sort': sort,
            },
        });
    }
    /**
     * Get transactions by date
     * @returns ChartDataDto List of transactions
     * @throws ApiError
     */
    public static getTransactionsByDate(): CancelablePromise<Array<ChartDataDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tx/bydate',
        });
    }
    /**
     * Get transactions by id
     * @param txId Tx ID
     * @returns Transaction List of transactions
     * @throws ApiError
     */
    public static getTransactionsById(
        txId: string,
    ): CancelablePromise<Transaction> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tx/{txId}',
            path: {
                'txId': txId,
            },
        });
    }
    /**
     * Get first and last transaction sent by account
     * @param account Account ID
     * @returns Transaction List of transactions
     * @throws ApiError
     */
    public static getFalTransactions(
        account: string,
    ): CancelablePromise<Array<Transaction>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tx/falTxs/{account}',
            path: {
                'account': account,
            },
        });
    }
}
